import clsx from "clsx";
import React from "react";
import { AutoSizer } from "react-virtualized";
import { FixedSizeList as List } from "react-window";

import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import AppPageTable from "components/AppPageTable";
import AppPageTableContent from "components/AppPageTableContent";
import HorseActionsMenu from "pages/HorseListPage/HorseActionsMenu";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import routes from "common/routes";
import HorseIcon from "components/Icons/Horse";
import Link from "components/Link";
import { getHorseAge, getHorseAgeSexColorValue } from "utils/horse";

import useStyles from "./styles";

export interface Props {
  horses: racehorse360.IHorse[];
  tableBodyRef: React.RefObject<HTMLDivElement>;
  refetchData: () => void;
}

const HorseList = (props: Props) => {
  const { horses, tableBodyRef, refetchData } = props;

  const classes = useStyles();

  const Row = ({ index, style }) => (
    <div
      key={horses[index].id}
      className={clsx(
        classes.rowLink,
        index % 2 ? classes.rowOdd : classes.rowEven
      )}
      style={style}
    >
      <HorseActionsMenu horse={horses[index]} refreshData={refetchData} />
      <Link
        to={routes.horseDetails.path.replace(
          ":horseId",
          String(horses[index].id)
        )}
      >
        <Grid container className={classes.row}>
          <Typography className={classes.name}>
            <HorseIcon className={classes.icon} />
            {horses[index].name}
          </Typography>
          <Box>
            <Typography className={classes.age}>
              {getHorseAge(horses[index], true)}
            </Typography>
            <Typography className={classes.color}>
              {getHorseAgeSexColorValue(horses[index], "%C %S")}
            </Typography>
          </Box>
        </Grid>
      </Link>
    </div>
  );

  return (
    <AppPageTable>
      <AppPageTableContent>
        <AutoSizer>
          {({ height, width }) => (
            <List
              className={classes.listVirtualized}
              itemCount={horses.length}
              itemSize={60}
              height={height}
              width={width}
              outerRef={tableBodyRef}
            >
              {Row}
            </List>
          )}
        </AutoSizer>
      </AppPageTableContent>
    </AppPageTable>
  );
};

export default React.memo(HorseList);
